import React from 'react';
import { Box } from '@mui/material';
import { func, bool, node } from 'prop-types';

import Switch from '@mui/material/Switch';

const BrowserItem = ({ headline, enabled, onClick }) => (
  <Box
    sx={{
      display: 'flex',
      height: '44px',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    <Box
      sx={{
        height: '22px',
        fontSize: '15px',
        lineHeight: 1.47,
      }}
    >
      {headline}
    </Box>
    <Box sx={{ ml: 'auto' }} onClick={() => onClick(!enabled)}>
      <Switch checked={enabled} />
    </Box>
  </Box>
);
BrowserItem.propTypes = {
  headline: node.isRequired,
  enabled: bool.isRequired,
  onClick: func.isRequired,
};

export default BrowserItem;
